// src/constants/taxConstants.js
// ============================================================================
// FRONTEND MIRROR of functions/constants/taxConstants.js
//
// The web-landing bundle can't reach into functions/, so the enums live in
// both places. Backend is the source of truth for validation; frontend uses
// these for dropdown options + display labels + UI threshold logic.
// ============================================================================

export const THRESHOLD_CENTS = 60000;
export const EARLY_WARNING_CENTS = 50000;
export const ESCALATION_CENTS = 100000;

export const TAX_FORM_TYPES = ['w9', 'w8ben'];

export const W9_TAX_CLASSIFICATIONS = {
  individual:   { id: 'individual',   displayName: 'Individual / sole proprietor / single-member LLC' },
  c_corp:       { id: 'c_corp',       displayName: 'C Corporation' },
  s_corp:       { id: 's_corp',       displayName: 'S Corporation' },
  partnership:  { id: 'partnership',  displayName: 'Partnership' },
  trust_estate: { id: 'trust_estate', displayName: 'Trust / estate' },
  llc_c:        { id: 'llc_c',        displayName: 'LLC (taxed as C-corp)' },
  llc_s:        { id: 'llc_s',        displayName: 'LLC (taxed as S-corp)' },
  llc_p:        { id: 'llc_p',        displayName: 'LLC (taxed as partnership)' },
  other:        { id: 'other',        displayName: 'Other' },
};

export const TAX_DOC_STATUS_LABELS = {
  pending_user_submission: { displayName: 'Pending — awaiting your submission', color: '#F59E0B' },
  submitted:               { displayName: 'Submitted',                          color: '#22C55E' },
  verified:                { displayName: 'Verified',                           color: '#10B981' },
  needs_update:            { displayName: 'Needs update',                       color: '#EF4444' },
  superseded:              { displayName: 'Superseded',                         color: '#6B7280' },
};

export function getCurrentTaxYear(nowMs = Date.now()) {
  return new Date(nowMs).getUTCFullYear();
}

export function formatThresholdDollars(cents) {
  return `$${(cents / 100).toFixed(0)}`;
}
